import {IhioReferenceItem} from "../../../../types/ihioPrescription";
import {MtoJDateFormat} from "../../../../utils/date";
import Tooltip from "../../general/tooltip";
import Icon from "../../general/icon";

type OrderedPrescriptionItemProps = {
    item: IhioReferenceItem;
}

const OrderedPrescriptionItem = ({
    item,
}: OrderedPrescriptionItemProps) => {

    const determineRemainingItems = () => {
        return item?.deliveredItems?.reduce((sum, item) => {

            return sum + (item.itemCount || 0);
        }, 0) || 0;
    }


    return (
        <div className={`card shadow-none border rounded-4 my-3 ${determineRemainingItems() === item?.itemCount ? 'border-green-success bg-light-green' : ''}`}>
            <div className={'card-body'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div>
                        {MtoJDateFormat(item?.activeDate)} - {item?.itemCount || 0} عدد
                        - {determineRemainingItems()} عدد تحویل داده شده
                    </div>
                    <bdi className={'d-flex align-items-center gap-3'}>
                        {determineRemainingItems() === item?.itemCount && (
                            <Tooltip alt={'تحویل داده شده است'}>
                                <span className={'text-success'}>
                                    <Icon name={'check-square'}/>
                                </span>
                            </Tooltip>
                        )}
                        <div
                            className={'badge badge-primary px-2 py-2'}
                            title={item?.shape?.name}
                        />
                        <bdi>
                            {item?.name}
                        </bdi>
                    </bdi>
                </div>
                {item?.description && (
                    <div className={'d-flex align-items-center'}>
                        <span className={'text-gray-600 me-3'}>
                            توضیحات:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.description}
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}


export default OrderedPrescriptionItem;